import { render, staticRenderFns } from "./NewBuildingsSlider.vue?vue&type=template&id=3debb494&scoped=true&lang=pug&"
import script from "./NewBuildingsSlider.vue?vue&type=script&lang=js&"
export * from "./NewBuildingsSlider.vue?vue&type=script&lang=js&"
import style0 from "./NewBuildingsSlider.vue?vue&type=style&index=0&id=3debb494&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3debb494",
  null
  
)

export default component.exports